const defaultContent = "Not available in this demo";

export default defaultContent;
